export enum AnswerStatus {
  Pending,
  Drafted,
  AwaitingPublishing,
  Done,
}
